import analyticstracker from "@jmc/analyticstracker";
import { EventTypes } from "@jmc/core/src/types/EventTypes";

export const siteSearchTracking = (keywordName: string, type: string = "general"): void => {
    analyticstracker().trackEvent({
        event: EventTypes.SEARCH_QUERY,
        info: { keyword: keywordName, type, resultcount: "unset" },
    });
};

export default siteSearchTracking;
